import React, { useEffect } from "react";
import { useState } from "react";
import * as R from 'ramda';
import { Menu } from '@headlessui/react';
import _ from "lodash";
import { colorMapping } from "../services/utils";

export function LibraryRendererComponent({ cellRendererParams, value }: any) {
  const [libraryElement, setLibraryElement] = useState<string>("");
  const [anchorOrderEl, setAnchorOrderEl] = React.useState(null);
  const [
    colorDecider,
    setColorDecider
  ] = useState<any>();

  const handleMenuClose = () => setAnchorOrderEl(null);

  const handleOrderSubmit = (value: any) => {
    if (cellRendererParams?.callback) {
      console.log("Invoking callback with value:", value);
      cellRendererParams.callback(value);
    } else {
      console.error("Callback function is not defined in cellRendererParams");
    }
    handleMenuClose();
  };

  const getDisplayText = (item: any) => {
    const key = cellRendererParams?.menuKey || "Value";
    const value = cellRendererParams?.menuValue || "Text";
    return {
      display: item[value] || item["Text"] || "",
      value: item[key] || item["Value"] || "",
    };
  };

  const getAnchorStyles = (position: string) => {
    switch (position) {
      case "top-right":
        return { top: 0, right: 0 };
      case "top-left":
        return { top: 0, left: 0 };
      case "bottom-right":
        return { bottom: 0, right: 0 };
      case "bottom-left":
        return { bottom: 0, left: 0 };
      default:
        return { top: "100%", left: 0 }; // Default below button
    }
  };

  const getRandomTextColor = () => {
    const red = Math.floor(Math.random() * 128);
    const green = Math.floor(Math.random() * 128);
    const blue = Math.floor(Math.random() * 128);
    const hexRed = red.toString(16).padStart(2, "0");
    const hexGreen = green.toString(16).padStart(2, "0");
    const hexBlue = blue.toString(16).padStart(2, "0");

    const hexCode = `#${hexRed}${hexGreen}${hexBlue}`;
    return hexCode;
  }

  const randomColor = getRandomTextColor();

  useEffect(() => {
    if (libraryElement && cellRendererParams?.isRowColorDecider) {
      const color = colorMapping[libraryElement] || "bg-gray-200";
      setColorDecider(color);
    }
  }, [libraryElement, cellRendererParams]);

  useEffect(() => {
    if (cellRendererParams?.library) {
      const libraryData = _.find(
        cellRendererParams?.library,
        (item: any) => item[cellRendererParams?.menuKey || "Value"] === value
      );
      setLibraryElement(
        libraryData ? libraryData[cellRendererParams?.menuValue || "Text"] : ""
      );
    }
  }, [cellRendererParams?.library, value, cellRendererParams?.menuKey, cellRendererParams?.menuValue]);

  return (
    <div>
      {cellRendererParams?.library && cellRendererParams?.isRowMenuSelect ? (
        <Menu as="div" className="relative text-left">
          <div>
            <Menu.Button
              onClick={(e: any) => setAnchorOrderEl(e.currentTarget)}
              className={`py-1 px-2 text-sm font-normal rounded-xl  delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-blue-300 duration-300 text-white whitespace-nowrap ${cellRendererParams?.isRowColorDecider ? colorDecider : ""}`}
              style={!cellRendererParams?.isRowColorDecider ? { backgroundColor: randomColor } : {}}
            >
              {libraryElement || 'Select'}
            </Menu.Button>
          </div>
          {anchorOrderEl && (
            <Menu.Items
              style={getAnchorStyles(cellRendererParams?.anchorPosition || "default")}
              className="absolute fixed z-10 bg-white border border-gray-300 rounded shadow-lg w-auto p-1 overflow: visible"
            >
              <div className="px-1 py-1">
                {_.map(cellRendererParams?.library, (item: any) => {
                  const { display, value } = getDisplayText(item);
                  return (
                    <Menu.Item key={value}>
                      <button
                        onClick={() => {
                          handleOrderSubmit(value);
                          handleMenuClose();
                        }}
                        className="p-2 hover:bg-gray-100 whitespace-nowrap"
                      >
                        {display}
                      </button>
                    </Menu.Item>
                  );
                })}
              </div>
            </Menu.Items>
          )}
        </Menu>
      ) : <div
        className={`py-1 px-2 text-sm font-normal rounded-xl  text-white whitespace-nowrap ${cellRendererParams?.isRowColorDecider ? colorDecider : ""}`}
        style={!cellRendererParams?.isRowColorDecider ? { backgroundColor: randomColor } : {}}
      >
        {libraryElement || 'Select'}
      </div>}


    </div>
  );
}
